var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2757 18.6551C25.2757 19.2404 25.0432 19.8017 24.6294 20.2156C24.2155 20.6295 23.6542 20.862 23.0689 20.862H3.20689C2.62158 20.862 2.06025 20.6295 1.64638 20.2156C1.23251 19.8017 1 19.2404 1 18.6551V6.51722C1 5.93191 1.23251 5.37058 1.64638 4.95671C2.06025 4.54284 2.62158 4.31033 3.20689 4.31033H7.62066L9.82755 1H16.4482L18.6551 4.31033H23.0689C23.6542 4.31033 24.2155 4.54284 24.6294 4.95671C25.0432 5.37058 25.2757 5.93191 25.2757 6.51722V18.6551Z",
    stroke: "#D1D4E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1379 16.4482C15.5756 16.4482 17.5517 14.472 17.5517 12.0344C17.5517 9.59672 15.5756 7.62061 13.1379 7.62061C10.7002 7.62061 8.72412 9.59672 8.72412 12.0344C8.72412 14.472 10.7002 16.4482 13.1379 16.4482Z",
    stroke: "#D1D4E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6760704ee6f897ed278e885ec7302487.svg";
export { ForwardRef as ReactComponent };